import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createSectionMediaStart,
  createSectionStart,
  deleteSectionStart,
  editSectionMediaStart,
  editSectionStart,
} from "../../redux/section/reducer";

import {
  selectIsCreatingSection,
  selectIsDeletingSection,
  selectIsEditingSection,
} from "../../redux/section/selectors";

const useSectionEditor = () => {
  const dispatch = useDispatch();
  const isEditing = useSelector(selectIsEditingSection);
  const isDeleting = useSelector(selectIsDeletingSection);
  const isCreatingSection = useSelector(selectIsCreatingSection);
  const createSection = useCallback(
    (data) => {
      dispatch(createSectionStart(data));
    },
    [dispatch]
  );

  const editSection = useCallback(
    (data) => {
      dispatch(editSectionStart(data));
    },
    [dispatch]
  );

  const deleteSection = useCallback(
    (data) => {
      dispatch(deleteSectionStart(data));
    },
    [dispatch]
  );
  const createSectionMedia = useCallback(
    (data) => {
      dispatch(createSectionMediaStart(data));
    },
    [dispatch]
  );

  const editSectionMedia = useCallback(
    (data) => {
      dispatch(editSectionMediaStart(data));
    },
    [dispatch]
  );
  return {
    isEditing,
    isDeleting,
    isCreatingSection,
    createSection,
    editSection,
    deleteSection,
    editSectionMedia,
    createSectionMedia,
  };
};

export default useSectionEditor;
